import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { Logo } from '@/components/heimdall/logo'
import { AcoesTopo } from '@/components/layout/acoes-topo'

/**
 * Tela fora do menu lateral (página não encontrada, sem permissão): topo em bloco com a marca, o tema e a conta, e o conteúdo
 * centralizado (na tela grande, também na altura, para não sobrar um vazio embaixo).
 */
export function TelaSimples({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className="heimdall-ground flex min-h-svh flex-col gap-3 p-3">
      <header className="heimdall-block mx-auto flex h-16 w-full max-w-6xl shrink-0 items-center gap-3 px-4">
        <a
          href="/"
          className="flex items-center gap-3 rounded-xl focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          <Logo tamanho="sm" />
          <span className="font-semibold">Heimdall</span>
        </a>
        <div className="ml-auto">
          <AcoesTopo />
        </div>
      </header>
      <main
        className={cn(
          'heimdall-entrada mx-auto grid w-full max-w-6xl flex-1 content-start gap-3 pt-3 pb-6 md:pt-8 lg:content-center lg:pb-16',
          className
        )}
      >
        {children}
      </main>
    </div>
  )
}
